import { createAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { createSliceSelector } from './utils/createSliceSelector';
const initialState = null;
export const setHighlight = createAction('setHighlight');
export const highlightSlice = createSlice({
    name: 'highlight',
    initialState,
    reducers: {},
    extraReducers: (builder) => builder.addCase(setHighlight, (state, { payload }) => payload),
});
export const selectionSelector = createSliceSelector(highlightSlice);
export const selectedHighlightSelector = createSelector(selectionSelector, (state) => state);
